const Footer = (props) => {
    return <footer>
    <h2>
      Casey Elizabeth
    </h2>
    <p>gilbertcasey2@gmail.com</p>
  </footer>
}

export default Footer;